import { render } from "./PackagePointsList.vue?vue&type=template&id=c37efd9c&scoped=true&ts=true"
import script from "./PackagePointsList.vue?vue&type=script&lang=ts"
export * from "./PackagePointsList.vue?vue&type=script&lang=ts"

import "./PackagePointsList.vue?vue&type=style&index=0&id=c37efd9c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37efd9c"]])

export default __exports__